import axios from "axios";
const API_URL = process.env.REACT_APP_TF_BLOG_LOCAL_URL
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  console.log(API_URL)
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      return Promise.reject({
        message: "Session expired. Please log in again.",
      });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
